import { ReactNode } from 'react';
import { Card } from '@/components/ui/card';

interface InventoryListFiltersCardProps {
  children: ReactNode;
  className?: string;
}

/** Filter row card — matches Products / Stock Takes list pages. */
export function InventoryListFiltersCard({ children, className }: InventoryListFiltersCardProps) {
  return (
    <Card className={className ?? 'mb-6'}>
      <div className="flex flex-wrap gap-4 p-4">{children}</div>
    </Card>
  );
}
